<div class="app-logo">
    <a routerLink="/">
        <ng-container *ngIf="LogoType == 'white'">
            <img style="width: 7rem;" src="assets/images/MatensaLogoTrademark.png" alt="" title="" />
        </ng-container>
        <ng-container *ngIf="LogoType != 'white'">
            <img style="width: 7rem;" src="assets/images/MatensaLogoWhite.png" alt="" title="" />
        </ng-container>
    </a>
</div>